import React, { Component } from "react";
import Popup from "reactjs-popup";
import { Button, Form, Row, Col, Alert } from "react-bootstrap";
import { FileDrop } from "react-file-drop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Loading } from "../components/Loading";
import ServiceCalls from "../utils/serviceCalls";
import TimedDisplay from "../components/TimedDisplay";
import RequestUtils from "../utils/requestUtils";
import CommonUtils from "../utils/siteUtils";
import "../styles/PopUps.css";
import "../styles/Vendor.css";

class AddAttachmentPopUp extends Component {
	constructor(props) {
		super(props);
		this.fileInputRef = React.createRef();
		this.state = {
			open: false,
			isLoading: true,
			attachCheck: "",
			attachLetter: "",
			attachFile: null,
			noFileCheck: false,
			noCheckBoxChecked: false,
			isSubmitComplete: false,
			addMsg: "",
			addMsgLevel: "",
			isValid: true,
			fileNameLength: 0
		};
	}

	componentDidMount() {
		if (this.props.Request) {
			this.setState({
				isLoading: false,
			});
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.Request !== prevProps.Request) {
			this.setState({ isLoading: false });
		}
	}

	closePopup = () => {
		this.setState({
			open: false,
			attachCheck: "",
			attachLetter: "",
			attachFile: null,
			noFileCheck: false,
			noCheckBoxChecked: false,
			addMsg: "",
			addMsgLevel: "",
			isSubmitComplete: false,
			isValid: true,
			fileNameLength:0,
            isValid: true,
           // isEMEAPlus: false
		});
	};

    openPopup = () => {
       // let isEMEAPlus = this.props.Request && this.props.Request.vendorRecord ? CommonUtils.determineIfVendorIsEMEAPlus(this.props.Request.vendorRecord) : false;
      //  if (isEMEAPlus) {
       //     this.setState({ isEMEAPlus: true });
       // } else {
            this.setState({ open: true });
      //  }
    };

	onFileUploadClick = () => {
		const fileInp = this.fileInputRef.current;
		fileInp.click();
	};

	onFileDrop = (files, event) => {
		event.preventDefault();
		this.onFileInputChange(event, files);
	};

	onFileInputChange = (e, droppedFiles) => {
		const files = droppedFiles || e.target.files;
		const maxFileSize = 1000000 * 5; // 5MB  
		var maxFileNameLength = 50;
		const acceptedFileTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "image/jpg", "image/bmp", "image/png", "image/jpeg"];
		let selectedFile = files[files.length - 1]; // get the last file  
		let isValid = false;
		//Add in standard file validation
		if (selectedFile !== null) {
			var fileNameLength = selectedFile.name.length;
			if (selectedFile.size <= maxFileSize) {
				if (acceptedFileTypes.includes(selectedFile.type)) {
					if (selectedFile.name.length <= maxFileNameLength) {
						isValid = true;
					}
				}
			}
			this.setState({
				attachFile: (isValid === true) ? selectedFile : null,
				isValid: isValid,
				fileNameLength: fileNameLength,
				noFileCheck: true
			});
		}
		else {
			//DE992153 - No file present
			this.setState({
				attachFile: null,
				isValid: false,
				fileNameLength: 0,
				noFileCheck: true
			});
		}


		//if (selectedFile && selectedFile.size <= maxFileSize && acceptedFileTypes.includes(selectedFile.type)) {
		//	isValid = true;		
		//}

		//this.setState({
		//	isValid: isValid,
		//	attachFile: isValid ? selectedFile : null,
		//	noFileCheck: true
		//});
	};  	



	onRemoveAttachment = () => {
		this.setState({
			attachFile: null,
			noFileCheck: false,
		});
	};

	onAttachTypeCheck = ({ target: { value } }) => {
		this.setState({
			attachLetter: value === "LETTER",
			attachCheck: value === "CHECK",
		});
	};
	
	submitAttachment = async () => { 
		const isEMEAPlus = CommonUtils.determineIfVendorIsEMEAPlus(this.props.Request.vendorRecord);
		if (this.state.attachFile && (this.state.attachLetter || this.state.attachCheck || isEMEAPlus)) {    
		  this.setState({    
			isLoading: true,    
		  });    
			//DE1001489
			var attachCheck = (isEMEAPlus) ? false : !(this.state.attachLetter);
		  //Had to create a quick object in order for the requestUtil to work 
		  let requestData = {  
			  attachFile: this.state.attachFile,  
			  attachCheck: attachCheck,  
			submitterContactId: this.props.currentUser.contactId
		  } 
		  
		  let request = RequestUtils.createAttachmentInfo(requestData, this.props.Request.bankRequest.vendorBankRequestId);  
			
		  try {    
			//Changed to 1 controller call. Uploads to event storage and adds to DB
			let data = await ServiceCalls.addAttachment(request);   
		
			if (data.isSuccessful) {  
			  this.setState({    
				addMsg: "Attachment added successfully",    
				addMsgLevel: "success",    
				isSubmitComplete: true,    
				isLoading: false,    
			  });    
			  this.props.loadTable();    
			} else {  
			  this.setState({    
				addMsg: data.errorMessage || "An error occurred while adding the attachment",    
				addMsgLevel: "danger",    
				isSubmitComplete: true,    
				isLoading: false,    
			  });    
			}  
		  }    
		  catch (error) {    
			this.setState({    
			  addMsg: error.message,    
			  addMsgLevel: "danger",    
			  isSubmitComplete: true,    
			  isLoading: false,    
			});    
		  }    
		}    
		else {    
		  this.setState({    
			noFileCheck: true,    
			  noCheckBoxChecked: true,   
			isValid:false
		  });    
		}    
	  };   
	  

	showAlertMessage = () => {
		if (this.state.isSubmitComplete) {
			return (
				<TimedDisplay delay="3000" callback={this.closePopup}>
					<Alert variant={this.state.addMsgLevel}>{this.state.addMsg}</Alert>
				</TimedDisplay>
			);
		} else {
			return <></>;
		}
	};


	render() {
		const {open, isLoading, attachCheck, attachLetter, attachFile, isSubmitComplete, noFileCheck, fileNameLength, isValid} = this.state; 
		const topAreaClass = "formSection";
		const isDisabled = isLoading || isSubmitComplete;
		var fileName = (attachFile) ? attachFile.name : (fileNameLength > 0) ? "" : "NO FILE";
		const isEMEAPlus = (open) ? CommonUtils.determineIfVendorIsEMEAPlus(this.props.Request.vendorRecord) : false;
		const renderPopupContent = () => (
			<div className="add-attachment-popup-area">
				<div className="eftStep">
					<Form id="attachAuthForm" noValidate className="form-horizontal">
						<div className={topAreaClass}>
							<Row className="eftStepHdrRow">
								<Col sm={12} className="eftStepHdrText">
									Attachments
								</Col>
							</Row>
							<Row className="eftStepRow">
								<Col>
									{isEMEAPlus ?
										"Must attach Bank Letter or Company Letter verifying the banking information provided. The letter provided must include company name, physical address, email address, phone number, signed and dated within 90 days." :
										"Must select and attach one:"
									}
								</Col>
							</Row>
							{!isEMEAPlus && (
								<>
									<Row className="eftAuthOpt eftStepRow">
										<Form.Group as={Col} sm={1} controlId="attachCheck">
											<Form.Check name="attachCheck" value="CHECK" type="checkbox" id="attachCheck" required={!(attachLetter || attachCheck)} isInvalid={!attachCheck && !attachLetter && this.state.noCheckBoxChecked} checked={attachCheck} onChange={this.onAttachTypeCheck} disabled={isDisabled} />
										</Form.Group>
										<Col sm={2}>
											<strong>Voided Check</strong>
										</Col>
										<Col sm={9} className="helperText">
											Deposit ticket not acceptable. Copy of Voided check should match the accounting information i.e. (Depository Bank Name, Depository Bank Address, Bank Transit & Bank Account # should match the information provided on ACH form.) If providing a check, it cannot be a counter check.
											Your business/name and a check number must be printed on the check. Direct Deposit enrollment forms, statements, online account printouts are not valid as bank representation.
										</Col>
									</Row>
									<Row className="eftAuthOpt eftStepRow">
										<Form.Group as={Col} sm={1} controlId="attachLetter">
											<Form.Check name="attachLetter" value="LETTER" type="checkbox" id="attachLetter" required={!(attachLetter || attachCheck)} isInvalid={!attachCheck && !attachLetter && this.state.noCheckBoxChecked} checked={attachLetter} onChange={this.onAttachTypeCheck} disabled={isDisabled} />
										</Form.Group>
										<Col sm={2}>
											<strong>Bank Letter</strong>
										</Col>
										<Col sm={9} className="helperText">
											A letter from my bank confirming the bank account and routing numbers. The bank letter must be on bank letterhead and include a bank authorizer name, title, physical address, email address, phone number, signed and dated within 90 days.
										</Col>
									</Row>
									<Row className="eftStepRow">
										<Col sm={12}>{!attachCheck && !attachLetter && this.state.noCheckBoxChecked ? <div className="error">Must select an attachment type</div> : <></>}</Col>
									</Row>
								</>
							)}
							<Row className="eftStepRow">
								{attachFile ? (
									<Form.Group as={Col} sm={12} controlId="attachFile" className="fileAttachmentArea">
										<Form.Label>
											File Attachment <span className="required">*</span>
										</Form.Label>
										<div className="eftUploadedFile">
											<div className="uploadedFileName">{attachFile.name}</div>
											<div className="right">
												<button title="Remove attachment" className="uploadFileImg" onClick={this.onRemoveAttachment} disabled={isDisabled}>
													<FontAwesomeIcon id="fa-remove" size="lg" icon={faTrashCan} />
												</button>
											</div>
										</div>
									</Form.Group>
								) : (
									<Form.Group as={Col} sm={12} controlId="attachFile" className="fileAttachmentArea">
										<Form.Label>
											File Attachment <span className="required">*</span>
										</Form.Label>
										<div className="eftFileUpload">
											<input onChange={this.onFileInputChange} ref={this.fileInputRef} type="file" style={{ display: "none" }} />
											<FileDrop onDrop={this.onFileDrop} onTargetClick={this.onFileUploadClick}>
												<div className="vCenter">Click to browse for file or drag and drop it here.</div>
											</FileDrop>
										</div>
										<span className="eftDetailText">Uploads are limited to under 5MB in size and file types of documents, JPG, PDF, PNG. File names must be under 50 characters.</span>
											{(noFileCheck && fileName === "NO FILE")
												? <div className='error'>No file uploaded</div>
												: (noFileCheck && isValid === false)
													? (Number(fileNameLength) > 50)
														? <div className='error'>File name must be under 50 characters.</div>
														: <div className='error'>Must attach a valid file. Uploads are limited to under 5MB in size and file types of documents, JPG, PDF, PNG.</div>
													: <></>}
									</Form.Group>
								)}
							</Row>
						</div>
					</Form>
				</div>
				<div>
					{this.state.isLoading ? (
						<Loading />
					) : this.state.isSubmitComplete ? (
						this.showAlertMessage()
					) : (
						<div className="attachment-buttons">
							<Button className="attachment-popup-buttons" type="submit" onClick={this.submitAttachment}>
								Add
							</Button>
							<Button className="attachment-popup-buttons" onClick={this.closePopup}>
								Cancel
							</Button>
						</div>
					)}
				</div>
			</div>
		);

		return (
			<>
				{!open && this.props.showButton() && (
					<Button id="mpa-button-popup" className="addCommentBtn right btn btn-primary" onClick={this.openPopup}>
						{" "}
						Add Attachment
					</Button>
				)}
				<Popup open={open}  modal closeOnDocumentClick={!open}>
					{renderPopupContent()}
				</Popup>
			</>
		);
	}
}

export default AddAttachmentPopUp;
